module.exports = __webpack_public_path__ + "img/icon-documents.61c82ce2.svg";